import { Payload, usePost, useDelete, useUpdate, useFetchMutation } from 'api/reactQuery/queryService';
import { objectify, Inline } from 'api/utils';
import { IBatchInfo } from 'components/common/DataGridDevEx/DataGrid.properties';
import { IDiaryFacade, IDiarySearchResponse } from 'api/swaggerTypes';
import { toObjectified } from 'api/baseApi';
import { APIRoutes } from './constants';

const diaryLinesResponseParser = (response): IDiarySearchResponse => {
    const { DiaryEntry } = response;

    return {
        ...response,
        DiaryEntry: DiaryEntry.map((responseObject) => objectify(responseObject as Inline<IDiaryFacade>))
    };
};
export type IRetrieveDiaryLinesPayload = Payload<any, IBatchInfo>;

const updateDairyResponseParser = (response) => ({
    ...response,
    DiaryEntry: response.DiaryEntry && toObjectified(response.DiaryEntry as Inline<IDiaryFacade>)
});

export const useUpdateDiary = (module) =>
    useUpdate<Payload<{ DiaryId: number; Subject: string; CommentFull: string }>, any>
        (APIRoutes[module?.name].diary.lines.update, { TableId: module?.tableId, DiaryType: '' }, { inline: true, responseParser: updateDairyResponseParser });

export const useRetrieveDiaryLines = (module) =>
    usePost<IRetrieveDiaryLinesPayload, any>
        (APIRoutes[module?.name].diary.lines.retrieve, { DiaryType: '' }, { inline: true, responseParser: diaryLinesResponseParser });

export const useDeleteDiaryLines = (module) =>
    useDelete<Payload<{ DiaryId: string }>>(APIRoutes[module?.name].diary.lines.delete, { TableId: module?.tableId, KeyId: module?.selectedItem, DiaryType: '' }, null);

const diaryDetailResponseParser = (response) => {
    const { DiaryEntry } = response;

    return {
        ...response,
        DiaryEntry: DiaryEntry ? toObjectified(DiaryEntry) : null
    };
};
export const useRetrieveDiaryDetail = (module) =>
    useFetchMutation<Payload<{ DiaryId?: string }>, any>(
        APIRoutes[module?.name].diary.detail.retrieve,
        null,
        {
            inline: true,
            responseParser: diaryDetailResponseParser
        }
    );

export const useCreateDiaryDetail = (module) =>
    usePost<Payload<any>, IDiaryFacade>
        (APIRoutes[module?.name].diary.detail.create, null, { inline: true, });
